import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const usePackageOffers = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState(null);
  if (!value) {
    setValue([
      {
        nicknameCenter: 'Centro Plus',
        nicknameProf: 'Gestionale Prof.',
        icon: 0,
        payment: t('PACKAGES-INFO.subscribe'),
        subscribed: t('NEW.subscribed'),
        title: t('PACKAGES-INFO.grow'),
        littleInfo: 'Tutte le funzionalitá FREE',
        priceCenterMonthly: `69.00`,
        priceProfesionalMonthly: `29.00`,
        priceCenterYearly: `690.00`,
        priceProfesionalYearly: `290.00`,
        offersCenter: ['Accesso collaboratori', 'Mobile App per collaboratori', 'Pagamenti online', 'NO COMMISSIONI SU PRENOTAZIONI'],
        offersProf: ['Accesso collaboratori', 'Mobile App per professionisti', 'Pagamenti online', 'NO COMMISSIONI SU PRENOTAZIONI'],
        offers: ['Accesso collaboratori', 'Mobile App per collaboratori', 'Pagamenti online', 'NESSUNA COMMISSIONE SU PAGEMENTI'],
      },
      {
        nicknameCenter: 'Plus+Video',
        nicknameProf: 'Prof. Plus + Video',
        icon: 1,
        payment: t('PACKAGES-INFO.subscribe'),
        subscribed: t('NEW.subscribed'),
        title: t('PACKAGES-INFO.video'),
        littleInfo: 'Tutte le funzionalitá GROW',
        priceCenterMonthly: `99.00`,
        priceProfesionalMonthly: `59.00`,
        priceCenterYearly: `990.00`,
        priceProfesionalYearly: `590.00`,
        offersCenter: ['Gestione catalogo video corsi', 'Video streaming platform (web/Mobile)', '1 Free Video class', '3% commissione'],
        offersProf: ['Gestione catalogo video corsi', 'Video streaming platform (web/Mobile)', '1 Free Video class', '3% commissione'],
        offers: ['Gestione catalogo video corsi', 'Video streaming platform (web/Mobile)', '1 Free Video class', '3% commissione'],
      },
      {
        nicknameCenter: 'Pacchetto Gestionale+Video+Mobile',
        nicknameProf: 'Prof. Plus + Video + Mobile',
        icon: 2,
        payment: t('PACKAGES-INFO.subscribe'),
        subscribed: t('NEW.subscribed'),
        title: t('PACKAGES-INFO.allInOne'),
        littleInfo: 'Tutte le funzionalitá VIDEO',
        priceCenterMonthly: `199.00`,
        priceProfesionalMonthly: `159.00`,
        priceCenterYearly: `1999.00`,
        priceProfesionalYearly: `1590.00`,
        offersCenter: [
          'Mobile app dedicata al tuo centro',
          'Personalizzatione: logo, colori',
          'Esclusiva per i tuoi clienti',
          'Aggiornamenti gratuiti',
        ],
        offersProf: [
          'Mobile app dedicata al tuo profilo da professionista',
          'Personalizzatione: logo, colori',
          'Esclusiva per i tuoi clienti',
          'Aggiornamenti gratuiti',
        ],
        offers: ['Mobile app dedicata al tuo centro', 'Personalizzatione: logo, colori', 'Esclusiva per i tuoi clienti', 'Aggiornamenti gratuiti'],
      },
    ]);
  }
  return value;
};

export { usePackageOffers };
